import {RivePreload} from "parts";
import {useTranslation} from "react-i18next";
import {getExperiment} from "utils";
import {useLocation} from "react-router-dom";
import React from "react";
import {LandingEnum} from "../_business";

export function Bottom({footer = true, preload, locale, children, className}) {
  const
    {t} = useTranslation('common', {keyPrefix: 'footer'}),
    location = useLocation()

  const
    isAgree = ['/', '/email', `/${window.landing}`, `/${window.landing}/email`].includes(location.pathname),
    A68 = getExperiment('A68', 'A'),

    A90 =
      ['/email'].includes(location.pathname) && window.landing !== LandingEnum.charisma
        ? {value: 'A'}
        : {value: 'B'}

    // A90 = {
    //   value: window.landing === LandingEnum.charisma
    //     ? 'B'
    //     : 'A'
    // }
      // window.landing === LandingEnum.default
      //   ? getExperiment('A90')
      //   : {value: 'A'}

  // if (!footer && !children)
  //   return (
  //     <>
  //       <p className={'mb-1'}/>
  //       {
  //         preload &&
  //         <RivePreload src={preload} locale={locale}/>
  //       }
  //     </>
  //   )

  return (
    // <div className={'bottom' + (children ? ' pt-0' : '')}>
    <div className={'bottom' + (className ? ' ' + className : '')}>
      {children}

      {
        footer && (
          A90.value === 'B'
            ?
            <footer className={'note md fw-400'} style={{fontSize: 10}}>
              <p className={'mb-1'}>99 Wall St #2512, New York, NY, USA, 10005 | +19178094487</p>
              <p>
                <a rel="noreferrer" href={process.env.REACT_APP_WEB_LINK + 'terms'} target={'_blank'}
                   className={'nowrap'}>{t('terms')}</a>
                <i className={'circle B'}/>
                <a rel="noreferrer" href={process.env.REACT_APP_WEB_LINK + 'privacy'} target={'_blank'}
                   className={'nowrap'}>{t('privacy')}</a>
                <i className={'circle B'}/>
                <a rel="noreferrer" href={process.env.REACT_APP_WEB_LINK + 'subscription'} target={'_blank'}
                   className={'nowrap'}>{t('subscription-policy')}</a>
              </p>
            </footer>
            : (
              !isAgree && (A68.value === 'A' || !['/email', `/${window.landing}/email`].includes(location.pathname))
                ?
                <footer>
                  <p>99 Wall St #2512, New York, NY, USA, 10005</p>
                  <a rel="noreferrer" href={process.env.REACT_APP_WEB_LINK + 'terms'} target={'_blank'}>{t('terms')}</a>
                  <i className={'circle'}/>
                  <a rel="noreferrer" href={process.env.REACT_APP_WEB_LINK + 'privacy'} target={'_blank'}>{t('privacy')}</a>
                </footer>
                :
                <footer className={'note md fw-400'}>
                  <p style={{marginBottom: 4}}>{t('title')}</p>
                  <p className={'mb-1'}>
                    <a rel="noreferrer" href={process.env.REACT_APP_WEB_LINK + 'terms'} target={'_blank'} className={'link nowrap'}>{t('terms-conditions')}</a>
                    <i className={'circle B'}/>
                    <a rel="noreferrer" href={process.env.REACT_APP_WEB_LINK + 'privacy'} target={'_blank'} className={'link nowrap'}>{t('privacy-policy')}</a>
                    <i className={'circle B'}/>
                    <a rel="noreferrer" href={process.env.REACT_APP_WEB_LINK + 'subscription'} target={'_blank'} className={'link nowrap'}>{t('subscription-policy')}</a>
                  </p>
                  {
                    !['/email', `/${window.landing}/email`].includes(location.pathname) &&
                    <p>99 Wall St #2512, New York, NY, USA, 10005</p>
                  }
                </footer>
            )
        )
      }

      {
        !footer &&
        <p className={'mb-1'}/>
      }

      {
        preload &&
        <RivePreload src={preload} locale={locale}/>
      }

      {
        process.env.REACT_APP_DEBUG &&
        <div style={{position: 'fixed', zIndex: 100, bottom: '5px', right: '5px'}}>{process.env.REACT_APP_VERSION}</div>
      }
    </div>
  )
}